import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviResourceApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.route = ENV.API_ROUTES?.REVI_RESOURCE || "revi-resource";
  }

  // audience ('therapist' | 'institution') filtra el material por destinatario.
  // Los recursos creados antes de que existiera el campo se siguen viendo como
  // material de terapeuta (tolerancia legacy en el servidor).
  async getResources(
    token,
    { page = 1, limit = 10, search = "", type, audience } = {},
  ) {
    const query = new URLSearchParams({ page, limit });

    if (search) query.append("search", search);
    if (type) query.append("type", type);
    if (audience) query.append("audience", audience);

    const url = `${this.baseApi}/${this.route}?${query.toString()}`;

    const params = {
      method: "GET",
      headers: cabecerasApi(token),
    };

    return this._fetch(url, params);
  }

  async getResourceById(token, id) {
    const url = `${this.baseApi}/${this.route}/${id}`;

    const params = {
      method: "GET",
      headers: cabecerasApi(token),
    };

    return this._fetch(url, params);
  }

  async _fetch(url, params) {
    const response = await fetch(url, params);
    const json = await response.json();

    if (response.status >= 200 && response.status < 300) return json;
    throw json;
  }
}
